import { LoadingComponent } from './loading/loading.component'
import { FastOrderComponent } from './fast_order/fast_order.component'
import { MessageComponent } from './dialog/message.component'
import { MoreReiviewsBtnComponent } from './reviews/more_reviews_btn.component'
import { StickyHeader } from './header/sticky.component'
import { CookieConsentBanner } from './cookie_consent/cookie_consent.component'

let components = {
  LoadingComponent,
  FastOrderComponent,
  MessageComponent,
  MoreReiviewsBtnComponent,
  StickyHeader,
  CookieConsentBanner
}

export default components;



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/shared/components.js